var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecklessDriving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Glass washer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15451",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11893",
    d: "M7.5 13l4.5 9",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11894",
    d: "M21.289 11.473L17.475 19.1a.987.987 0 01-1.289.466 10.391 10.391 0 00-8.576 0 .988.988 0 01-1.29-.466l-3.813-7.627a1 1 0 01.418-1.332 19.871 19.871 0 0117.945 0 1 1 0 01.419 1.332z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11895",
    d: "M17.587 2.879a3.122 3.122 0 00-.394-.308",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11896",
    d: "M14.381 2.113a3.337 3.337 0 00-1.423.766 3.066 3.066 0 00-.3.31",
    stroke: "currentColor",
    strokeDasharray: "0.586 2.932"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11897",
    d: "M12.045 4.5A2.767 2.767 0 0012 5a2.767 2.767 0 00-.045-.5",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11898",
    d: "M10.178 2.31a3.546 3.546 0 00-2-.267",
    stroke: "currentColor",
    strokeDasharray: "0.586 2.932"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11899",
    d: "M6.807 2.57a3.225 3.225 0 00-.394.309",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11900",
    d: "M12 13v-1",
    stroke: "#304393",
    strokeDasharray: "1 5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11901",
    d: "M12 9V8",
    stroke: "#304393",
    strokeDasharray: "1 5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11902",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgRecklessDriving;


//////////////////
// WEBPACK FOOTER
// ./src/icons/recklessDriving.svg
// module id = 795
// module chunks = 13